import {
  changeEduStatus,
  noiccStatus,
  eoiStatus,
  roiStatus,
  changeVisaStatus,
} from "../../../utilis/appStatus";
import {
  mergeCommissionsClientLookupParams,
  resolveCommissionsSearchParams,
} from "./commissionsSearchUtils";

export const CMS_PRIMARY = "#007BFF";

/** Shared compact filter toolbar tokens */
export const FILTER_CARD_CLASS =
  "overflow-hidden rounded-[12px] border border-[#E5E7EB] bg-white p-4 shadow-sm";

export const FILTER_PANEL_INNER_CLASS = "rounded-lg bg-[#F1F5F9] p-3";

export const FILTER_LABEL_CLASS =
  "mb-1.5 block text-[12px] font-medium leading-none text-gray-600";

export const FILTER_TRIGGER_CLASS =
  "flex h-10 w-full items-center justify-between gap-2 rounded-lg border border-[#E5E7EB] bg-white px-3 text-[13px] text-gray-800 outline-none shadow-sm transition hover:border-gray-300 focus:border-[#007BFF] focus:ring-1 focus:ring-[#007BFF]/20";

export const FILTER_TRIGGER_OPEN_CLASS =
  "border-[#007BFF]/50 ring-1 ring-[#007BFF]/15";

export const FILTER_SEARCH_CLASS =
  "h-9 w-full rounded-md border border-[#E5E7EB] bg-white pl-8 pr-8 text-[13px] text-gray-900 shadow-sm outline-none transition placeholder:text-gray-400 hover:border-gray-300 focus:border-[#007BFF] focus:ring-1 focus:ring-[#007BFF]/20";

/** Filter rows — responsive grid (1 / 2 / 4 columns) */
export const FILTER_ROW_CLASS =
  "cms-commissions-filter-row w-full";

export const COMMISSIONS_FILTER_ROW_CLASS =
  "cms-commissions-filter-row w-full";

export const COMMISSIONS_FILTER_FIELD_CLASS = "min-w-0";

export const FILTER_FIELD_CLASS = "min-w-0";

export const FILTER_CHEVRON_CLASS =
  "shrink-0 text-gray-400 transition-transform duration-200";

/** Reset global Bootstrap/button styles on portaled dropdown menus */
export const FILTER_DROPDOWN_BTN_RESET = {
  border: "none",
  outline: "none",
  WebkitAppearance: "none",
  appearance: "none",
  boxShadow: "none",
};

export const FILTER_DROPDOWN_LIST_STYLE = {
  listStyle: "none",
  margin: 0,
  padding: "4px 0",
};

export const FILTER_DROPDOWN_LI_RESET = {
  margin: 0,
  padding: 0,
  listStyle: "none",
};

export function getDropdownOptionStyle(selected) {
  return {
    ...FILTER_DROPDOWN_BTN_RESET,
    background: selected ? "rgba(0, 123, 255, 0.08)" : "transparent",
    color: selected ? "#007BFF" : "#4B5563",
    fontWeight: selected ? 600 : 400,
    cursor: "pointer",
    width: "100%",
    textAlign: "left",
    padding: "6px 12px",
  };
}

export const APPLICATION_TYPES = [
  { id: "education", title: "Education" },
  // Migration tab temporarily hidden — keep for later restore
  // { id: "migration", title: "Migration" },
];

export const REPORT_TABS = [
  { id: "general", label: "General Report" },
  { id: "commission", label: "Commissionable Students" },
  { id: "inquiry_batches", label: "Inquiry Batches" },
];

export const LOCATION_OPTIONS = [
  { id: "onshore", name: "Onshore" },
  { id: "offshore", name: "Offshore" },
];

export const DATE_PRESETS = [
  { id: "all", label: "All time" },
  { id: "last_7_days", label: "Last 7 days" },
  { id: "last_30_days", label: "Last 30 days" },
  { id: "custom", label: "Custom range" },
];

export const GENERAL_TABLE_COLUMNS = [
  { title: "", key: "select", sortable: false, canToggle: false },
  { title: "Client Name", key: "clientname", defaultVisible: true },
  {
    title: "Processing Agent",
    key: "external_processing_agent",
    sortable: false,
    defaultVisible: false,
  },
  {
    title: "Referring Agent",
    key: "external_referring_agent",
    sortable: false,
    defaultVisible: false,
  },
  {
    title: "Processing Branch",
    key: "processing_branch",
    sortable: false,
    defaultVisible: false,
  },
  {
    title: "Referring Branch",
    key: "referring_branch",
    sortable: false,
    defaultVisible: false,
  },
  {
    title: "Provider & Course",
    key: "providername",
    sortKeys: ["providername", "coursename"],
    defaultVisible: true,
  },
  { title: "Status", key: "history_status_title", defaultVisible: true },
  { title: "Intake", key: "intake", defaultVisible: true },
  { title: "Documents", key: "documents", sortable: false, defaultVisible: false },
  {
    title: "Total Installments",
    key: "total_installments",
    sortable: false,
    defaultVisible: false,
  },
  {
    title: "Paid Installments",
    key: "paid_installments",
    sortable: false,
    defaultVisible: false,
  },
  { title: "Last Updated", key: "statuschangedate", defaultVisible: true },
  { title: "Actions", key: "actions", sortable: false, canToggle: false },
];

/** @deprecated Use GENERAL_TABLE_COLUMNS */
export const TABLE_COLUMNS = GENERAL_TABLE_COLUMNS;

export const COMMISSION_TABLE_COLUMNS = [
  { title: "", key: "select", sortable: false, canToggle: false },
  { title: "Student", key: "clientName", sortable: false, defaultVisible: true },
  { title: "Student ID", key: "studentId", sortable: false, defaultVisible: false },
  { title: "DOB", key: "dob", sortable: false, defaultVisible: false },
  { title: "Course", key: "course", sortable: false, defaultVisible: true },
  { title: "Provider", key: "provider", sortable: false, defaultVisible: true },
  {
    title: "Processing Agent",
    key: "processing_agent",
    sortable: false,
    defaultVisible: false,
  },
  {
    title: "Referring Agent",
    key: "referring_agent",
    sortable: false,
    defaultVisible: false,
  },
  {
    title: "Processing Branch",
    key: "processing_branch",
    sortable: false,
    defaultVisible: false,
  },
  {
    title: "Referring Branch",
    key: "referring_branch",
    sortable: false,
    defaultVisible: false,
  },
  { title: "Intake", key: "intake", sortable: false, defaultVisible: true },
  {
    title: "Status",
    key: "history_status_title",
    sortable: false,
    defaultVisible: true,
  },
  { title: "Start", key: "start", sortable: false, defaultVisible: false },
  { title: "End", key: "end", sortable: false, defaultVisible: false },
  {
    title: "Student Outcome",
    key: "student_outcome",
    sortable: false,
    defaultVisible: true,
  },
  {
    title: "Commission Status",
    key: "commission_workflow_status",
    sortable: false,
    defaultVisible: true,
  },
  { title: "Documents", key: "documents", sortable: false, defaultVisible: false },
  { title: "Batch", key: "batch", sortable: false, defaultVisible: false },
  { title: "Actions", key: "actions", sortable: false, canToggle: false },
];

/**
 * Sub-views of Commissionable Students. Everything is derived from the workflow
 * fields the backend writes, so a student never has to be moved between lists.
 */
export const COMMISSION_QUEUE_VIEWS = [
  {
    id: "all",
    label: "All",
    hint: "Every commissionable student, ever",
  },
  {
    id: "active",
    label: "Active",
    hint: "Students still in play",
  },
  {
    id: "exceptions_reconciliation",
    label: "Exceptions",
    hint:
      "Exceptions & Reconciliation — withdrawn, discontinued, visa refused, refunds, and commission statuses needing reconciliation or adjustment",
  },
  {
    id: "completed",
    label: "Completed",
    hint: "Commission reconciled — ready for optional final review",
  },
  {
    id: "final_review",
    label: "Final Review",
    hint: "Awaiting supervisor sign-off",
  },
];

export const PER_PAGE_OPTIONS = [10, 25, 50, 100, 200];

export const EMPTY_FILTERS = {
  type: "education",
  report: "general",
  commissionView: "active",
  providerId: null,
  courseId: null,
  intakeId: null,
  location: null,
  processingAgentId: null,
  referringAgentId: null,
  processingBranchId: null,
  referringBranchId: null,
  statuses: [],
  dateRange: { preset: "all", startDate: "", endDate: "" },
  clientUserId: "",
  clientDob: "",
  searchTerm: "",
  sortBy: "statuschangedate",
  sortDir: "desc",
};

export function getStatusGroups(type) {
  if (type === "education") {
    return [
      { key: "education", label: "Education Status", items: changeEduStatus },
    ];
  }
  if (type === "migration") {
    return [
      { key: "noicc", label: "NOICC Status", items: noiccStatus },
      { key: "eoi", label: "EOI Status", items: eoiStatus },
      { key: "roi", label: "ROI Status", items: roiStatus },
      { key: "visa", label: "Visa Status", items: changeVisaStatus },
    ];
  }
  return [];
}

export function getProviderCategory(type) {
  if (type === "education") return 8;
  if (type === "migration") return 1;
  return null;
}

export function resolveDateRange(dateRange) {
  if (!dateRange) return { startDate: "", endDate: "" };
  if (dateRange.preset === "custom") {
    return {
      startDate: dateRange.startDate || "",
      endDate: dateRange.endDate || "",
    };
  }
  if (dateRange.preset === "all") {
    return { startDate: "", endDate: "" };
  }
  const end = new Date();
  const start = new Date();
  if (dateRange.preset === "last_7_days") start.setDate(start.getDate() - 7);
  if (dateRange.preset === "last_30_days") start.setDate(start.getDate() - 30);
  const fmt = (d) => d.toISOString().slice(0, 10);
  return { startDate: fmt(start), endDate: fmt(end) };
}

export function getStatusBadgeClass(statusTitle = "") {
  const title = statusTitle.toLowerCase();

  if (
    title.includes("refused") ||
    title.includes("withdrawn") ||
    title.includes("discontinued") ||
    title.includes("cancelled") ||
    title.includes("invalid") ||
    title.includes("no commission") ||
    title.includes("expired") ||
    title.includes("offer not accepted") ||
    title.includes("visa cancelled")
  ) {
    return "bg-red-50 text-red-700 border border-red-200";
  }

  if (
    title.includes("commission received") ||
    title.includes("visa approved") ||
    title.includes("visa application approved") ||
    title.includes("enrolled") ||
    title.includes("offer accepted") ||
    title.includes("fee paid") ||
    title.includes("refund paid") ||
    title.includes("full offer") ||
    title.includes("gs approved") ||
    title.includes("application approved") ||
    title.includes("invitation received")
  ) {
    return "bg-emerald-50 text-emerald-700 border border-emerald-200";
  }

  if (title.includes("visa application submitted")) {
    return "bg-violet-50 text-violet-700 border border-violet-200";
  }

  if (
    title.includes("conditional offer") ||
    title.includes("deferred offer") ||
    title.includes("deferral")
  ) {
    return "bg-cyan-50 text-cyan-700 border border-cyan-200";
  }

  if (
    title.includes("gte") ||
    title.includes("gs assessment") ||
    title.includes("info requested") ||
    title.includes("rfi received") ||
    title.includes("noicc received") ||
    title.includes("natural justice received")
  ) {
    return "bg-amber-50 text-amber-800 border border-amber-200";
  }

  if (
    title.includes("info submitted") ||
    title.includes("application lodged") ||
    title.includes("eoi submitted") ||
    title.includes("roi submitted") ||
    title.includes("response submitted") ||
    title.includes("rfi submitted") ||
    title.includes("noicc response")
  ) {
    return "bg-blue-50 text-blue-700 border border-blue-200";
  }

  if (title.includes("application received")) {
    return "bg-sky-50 text-sky-700 border border-sky-200";
  }

  if (title.includes("prospect")) {
    return "bg-slate-100 text-slate-600 border border-slate-200";
  }

  if (title.includes("pending") || title.includes("review")) {
    return "bg-orange-50 text-orange-700 border border-orange-200";
  }

  if (title.includes("document")) {
    return "bg-indigo-50 text-indigo-700 border border-indigo-200";
  }

  if (title.includes("refund applied")) {
    return "bg-gray-100 text-gray-600 border border-gray-200";
  }

  return "bg-gray-100 text-gray-600 border border-gray-200";
}

function parseDisplayDate(value) {
  if (value == null || value === "") return null;
  const raw = String(value).trim();
  if (!raw) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const dateOnly = new Date(`${raw}T00:00:00`);
    return Number.isNaN(dateOnly.getTime()) ? null : dateOnly;
  }

  const normalized = raw.replace(/(\.\d{3})\d+(Z)?$/i, "$1$2");
  const parsed = new Date(normalized);
  if (!Number.isNaN(parsed.getTime())) return parsed;

  const datePart = raw.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
    const fallback = new Date(`${datePart}T00:00:00`);
    return Number.isNaN(fallback.getTime()) ? null : fallback;
  }

  return null;
}

export function formatDisplayDate(dateStr) {
  const d = parseDisplayDate(dateStr);
  if (!d) return "";
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function resolveApplicationAgentDisplay(application, kind = "processing") {
  if (!application) return "";
  if (kind === "processing") {
    return (
      application.external_processing_agency ||
      application.external_processing_agent_name ||
      application.processing_agent_name ||
      application.external_processing ||
      application.external_processing_agent ||
      ""
    );
  }
  return (
    application.external_referring_agency ||
    application.external_referring_agent_name ||
    application.referring_agent_name ||
    application.external_referring ||
    application.external_referring_agent ||
    ""
  );
}

export function resolveApplicationBranchDisplay(application, kind = "processing") {
  if (!application) return "";
  if (kind === "processing") {
    return (
      application.processing_branch ||
      application.superagentname ||
      application.superagent_name ||
      ""
    );
  }
  return (
    application.referring_branch ||
    application.subagentname ||
    application.subagent_name ||
    ""
  );
}

export function normalizeCommissionView(view) {
  const id = String(view || "")
    .trim()
    .toLowerCase();
  const legacy = {
    exceptions: "exceptions_reconciliation",
    reconciliation: "exceptions_reconciliation",
    attention: "exceptions_reconciliation",
  };
  if (legacy[id]) {
    return legacy[id];
  }
  const valid = COMMISSION_QUEUE_VIEWS.map((entry) => entry.id);
  if (valid.includes(id)) {
    return id;
  }
  return "active";
}

export function buildFilterParams(filters, pagination) {
  const { startDate, endDate } = resolveDateRange(filters.dateRange);
  const report = filters.report || "general";
  const queue =
    report === "no_commission"
      ? "inquiry"
      : report === "commission"
        ? "commission"
        : "general";

  const searchParams = mergeCommissionsClientLookupParams(
    resolveCommissionsSearchParams(filters.searchTerm),
    filters.clientUserId,
    filters.clientDob,
  );

  return {
    page: pagination.currentPage,
    perPage: pagination.perPage,
    type: filters.type === "all" ? undefined : filters.type?.toLowerCase(),
    providerId: filters.providerId || undefined,
    courseId: filters.courseId || undefined,
    intakeId: filters.intakeId || undefined,
    location: filters.location || undefined,
    external_processing_agent: filters.processingAgentId || undefined,
    external_referring_agent: filters.referringAgentId || undefined,
    superagent: filters.processingBranchId || undefined,
    subagent: filters.referringBranchId || undefined,
    statuses:
      filters.statuses?.length > 0
        ? filters.statuses.map((s) => String(s.value)).join(",")
        : undefined,
    startDate: startDate || undefined,
    endDate: endDate || undefined,
    searchTerm: searchParams.searchTerm,
    client_id: searchParams.client_id,
    user_id: searchParams.user_id,
    dob: searchParams.dob,
    queue,
    commission_view:
      queue === "commission"
        ? normalizeCommissionView(filters.commissionView || "active")
        : undefined,
    expand_package_courses:
      queue === "commission" && report === "commission" ? true : undefined,
    sort_by: filters.sortBy,
    sort_dir: filters.sortDir,
  };
}

/** Colour cues for the derived outcome / commission status values. */
const COMMISSION_STATUS_TONES = {
  // Good / on track
  Active: "emerald",
  Eligible: "emerald",
  Reconciled: "emerald",
  Paid: "emerald",
  // Waiting
  "Awaiting Commencement": "sky",
  Potential: "sky",
  "Not Yet Due": "sky",
  // Paused
  Deferred: "amber",
  "Deferral Requested": "amber",
  "On Hold": "amber",
  "Refund Requested": "amber",
  Applied: "amber",
  // Needs a human
  "Under Review": "orange",
  "Review Required": "orange",
  "Reconciliation Required": "orange",
  "Adjustment Required": "orange",
  // Ended
  Withdrawn: "rose",
  Discontinued: "rose",
  "Visa Refused": "rose",
  "Not Proceeding": "rose",
  Refunded: "rose",
  "Not Eligible": "rose",
  Closed: "gray",
  "Final Review": "violet",
};

export function getCommissionStatusTone(value) {
  return COMMISSION_STATUS_TONES[String(value || "").trim()] || "gray";
}

/**
 * Short label for workflow badges in dense tables: first word + 3 letters of the
 * second word + "…" (hover shows full text). Single long words are clipped.
 */
export function compactWorkflowStatusLabel(text, secondWordChars = 3) {
  const full = String(text || "").trim();
  if (!full) {
    return { display: "", full: "" };
  }

  const words = full.split(/\s+/).filter(Boolean);
  if (words.length === 1) {
    const word = words[0];
    if (word.length <= 11) {
      return { display: word, full };
    }
    return { display: `${word.slice(0, 9)}…`, full };
  }

  const first = words[0];
  const second = words[1];
  const snippet = second.slice(0, secondWordChars);
  const needsEllipsis =
    second.length > secondWordChars || words.length > 2;

  if (!needsEllipsis) {
    return { display: `${first} ${second}`, full };
  }

  return { display: `${first} ${snippet}…`, full };
}

/** True when the application is already at Discontinued (education or migration). */
export function isApplicationDiscontinued(application = {}) {
  const outcome = String(application?.student_outcome || "").trim();
  if (outcome === "Discontinued") {
    return true;
  }

  const status = Number(application?.status);
  if (!Number.isFinite(status)) return false;

  if (application?.category === "migration") {
    return status === 13 || status <= -13;
  }

  return status === 7 || status <= -7;
}

function isDiscontinuedStatusValue(status, category = "education") {
  const value = Number(status);
  if (!Number.isFinite(value)) return false;

  if (category === "migration") {
    return value === 13 || value <= -13;
  }

  return value === 7 || value <= -7;
}

function normalizeStatusHistoryList(history) {
  if (Array.isArray(history)) return history;
  if (history && typeof history === "object") return Object.values(history);
  return [];
}

function historyStatusValue(entry) {
  const value = Number(entry?.status_value ?? entry?.status ?? entry?.value);
  return Number.isFinite(value) ? value : null;
}

function isDiscontinuedHistoryEntry(entry, category = "education") {
  const title = String(entry?.status_title || entry?.title || "").toLowerCase();
  if (title.includes("discontinu")) return true;

  const value = historyStatusValue(entry);
  if (value == null) return false;

  if (category === "migration") {
    return value === 13 || value === -13;
  }

  return value === 7 || value === -7;
}

function findStatusTitleInHistory(history, statusValue) {
  const target = Number(statusValue);
  if (!Number.isFinite(target)) return "";

  for (let i = history.length - 1; i >= 0; i -= 1) {
    const entry = history[i];
    if (historyStatusValue(entry) === target) {
      return String(entry?.status_title || entry?.title || "").trim();
    }
  }

  return "";
}

function resolveStatusTitle(value, category, fallbackTitle = "") {
  const trimmed = String(fallbackTitle || "").trim();
  if (trimmed) return trimmed;

  const list = category === "migration" ? changeVisaStatus : changeEduStatus;
  const match = (list || []).find((item) => Number(item?.value) === Number(value));
  return match?.title || defaultActiveStatusMeta(category).statusText;
}

function historyTimestamp(entry) {
  return (
    parseDisplayDate(
      entry?.status_change_at || entry?.status_change_date || entry?.created_at,
    )?.getTime() || 0
  );
}

function sortHistoryChronological(history) {
  return [...history].sort((a, b) => {
    const idA = Number(a?.id || 0);
    const idB = Number(b?.id || 0);
    if (idA !== idB) return idA - idB;
    return historyTimestamp(a) - historyTimestamp(b);
  });
}

function defaultActiveStatusMeta(applicationType = "education") {
  if (applicationType === "migration") {
    return { status: 100, statusText: "Visa Granted" };
  }

  return { status: 100, statusText: "Offer Accepted - Fee Paid" };
}

/** Status payload to restore a discontinued commission row back to Active. */
export function getReactivateStatusMeta(application = {}) {
  const category = application?.category || "education";
  const history = normalizeStatusHistoryList(application?.status_history);
  const chronological = sortHistoryChronological(history);

  let latestDiscontinueIndex = -1;
  for (let i = chronological.length - 1; i >= 0; i -= 1) {
    if (isDiscontinuedHistoryEntry(chronological[i], category)) {
      latestDiscontinueIndex = i;
      break;
    }
  }

  if (latestDiscontinueIndex > 0) {
    for (let i = latestDiscontinueIndex - 1; i >= 0; i -= 1) {
      const entry = chronological[i];
      if (isDiscontinuedHistoryEntry(entry, category)) continue;
      const value = historyStatusValue(entry);
      if (value == null) continue;

      return {
        status: value,
        statusText: resolveStatusTitle(
          value,
          category,
          entry?.status_title || entry?.title,
        ),
      };
    }
  }

  const currentStatus = Number(application?.status);
  if (
    Number.isFinite(currentStatus) &&
    !isDiscontinuedStatusValue(currentStatus, category)
  ) {
    return {
      status: currentStatus,
      statusText: resolveStatusTitle(
        currentStatus,
        category,
        findStatusTitleInHistory(history, currentStatus),
      ),
    };
  }

  return defaultActiveStatusMeta(category);
}

/** Status payload used by the same API as the application detail page. */
export function getDiscontinuedStatusMeta(applicationType = "education") {
  if (applicationType === "migration") {
    return { status: 13, statusText: "Discontinued" };
  }

  return { status: 7, statusText: "Discontinued" };
}

const COMMISSION_COMPLETED_STATUSES = ["Reconciled", "Paid"];

/** True when the student is in the Completed commission tab bucket. */
export function isApplicationCommissionCompleted(application = {}) {
  const status = String(application?.commission_workflow_status || "").trim();
  return COMMISSION_COMPLETED_STATUSES.includes(status);
}

export function isApplicationFinalReviewPending(application = {}) {
  return String(application?.final_review_status || "").trim() === "pending";
}

/** Terminal state after Approve & Close on the Final Review tab (not workflow "Closed" from discontinue). */
export function isApplicationCommissionClosed(application = {}) {
  return Boolean(application?.final_review_closed_at);
}

export function isApplicationExceptionsReconciliation(application = {}) {
  if (isApplicationFinalReviewPending(application)) return false;
  if (isApplicationCommissionClosed(application)) return false;
  if (isApplicationCommissionCompleted(application)) return false;

  const outcome = String(application?.student_outcome || "").trim();
  const workflow = String(application?.commission_workflow_status || "").trim();
  const refund = String(application?.refund_status || "").trim();

  const exceptionOutcomes = [
    "Visa Refused",
    "Withdrawn",
    "Discontinued",
    "Not Proceeding",
    "Refund Requested",
    "Refunded",
    "Deferral Requested",
  ];
  const reconStatuses = [
    "Reconciliation Required",
    "Adjustment Required",
    "Review Required",
  ];

  if (exceptionOutcomes.includes(outcome)) return true;
  if (reconStatuses.includes(workflow)) return true;
  if (refund === "Applied" || refund === "Paid") return true;

  return false;
}

export function canSendApplicationForFinalReview(application = {}) {
  if (isApplicationFinalReviewPending(application)) return false;
  if (isApplicationCommissionClosed(application)) return false;

  return (
    isApplicationCommissionCompleted(application) ||
    isApplicationExceptionsReconciliation(application)
  );
}
